import {CopyButton} from '@wandb/components';
import Prism from 'prismjs';
import React, {useEffect, useRef} from 'react';

import {useOnCopyAnalytics} from '../../services/analytics';

type ReproduceStepsProps = {steps: string[]; title: string};
export function ReproduceSteps({steps, title}: ReproduceStepsProps) {
  const ref = useRef<HTMLTableElement>(null);
  useEffect(() => {
    if (ref.current != null) {
      ref.current.querySelectorAll('td code').forEach(code => {
        Prism.highlightElement(code);
      });
    }
  }, [steps]);

  const onCopyAllCommands = useOnCopyAnalytics('Reproduce run', {
    action: 'copy property',
    proeprty: 'all commands',
  });
  const onCopySingleCommand = useOnCopyAnalytics('Reproduce run', {
    action: 'copy property',
    proeprty: 'single commands',
  });

  return (
    <div>
      <div className="flex flex-row justify-between items-center  py-4">
        <div className="font-semibold text-moon-600 dark:text-wb-text-secondary">
          {title}
        </div>
        <CopyButton content={steps.join(' && ')} onCopy={onCopyAllCommands} />
      </div>
      <div className="border font-mono text-[13px] leading-[20px] p-8 border-moon-200 dark:border-wb-border rounded-lg bg-moon-100 dark:bg-wb-surface-sunken">
        <table className="break-all" ref={ref}>
          <tbody>
            {steps.map(step => {
              return (
                <tr key={step} className="group">
                  <td className="select-none align-text-top">$</td>
                  <td className="align-text-top w-full">
                    <code className="language-sh block break-all -indent-16 pl-24">
                      {step}
                    </code>
                  </td>
                  {steps.length > 1 ? (
                    <td className="select-none align-text-top break-normal focus-within:opacity-100 group-hover:opacity-100 opacity-0 transition-all">
                      {/* Adding padding to the top of this cell or content
                      within this cell just adds padding to the top of the row,
                      because table elements are an unpredictable mess! So
                      instead, introduce some relative positioning to get what
                      I want.*/}
                      <div className="relative top-4">
                        <CopyButton
                          content={step}
                          size="sm"
                          onCopy={onCopySingleCommand}
                        />
                      </div>
                    </td>
                  ) : null}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
